// extracted by mini-css-extract-plugin
export default {"nav-items":"page-nav__nav-items___PtL3","active":"page-nav__active__kVXtE","activeTappable":"page-nav__activeTappable__Va5f1","inactiveTappable":"page-nav__inactiveTappable__tRoWv"};